import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
//uncommentng serve
import * as jspdf from 'jspdf';
import * as html2canvas from 'html2canvas';

import { environment } from '../../../../environments/environment';
import { FileUploader } from 'ng2-file-upload/ng2-file-upload';
const filesize = require('filesize');
import * as _ from 'underscore';
import { CommercialService } from './../../questionnaire/commercial.service';
import { HttpClient, HttpParams } from '@angular/common/http';

@Component({
  selector: 'app-pre-congrats',
  templateUrl: './pre-congrats.component.html',
  styleUrls: ['./pre-congrats.component.css'],
})
export class PreCongratsComponent implements OnInit {
  isPdfContent = false;
  errorMsg = false;
  invalidFileMsg = false;
  url = environment.api_url;
  uploadedFilename = [];
  display = 'none';
  hasAnotherDropZoneOver = false;
  invalidFileSizeMsg = false;
  showTyping = false;
  typingTimer;
  timer;
  time = 1000;
  showArrowbox2 = false;
  public uploader: FileUploader = new FileUploader({
    url: this.url + '/commercialfileupload',
    itemAlias: 'photo',
  });

  // For PDF
  contactInfo;
  address;
  buisnessName;
  footerDate;
  headerDate;
  fileName;

  // For address
  state = '';
  city = '';
  zipCode = '';
  streetNo = '';
  streetAdd1 = '';
  streetAdd2 = '';
  country = '';
  utilities = [
    {
      utility: 'Oncor',
      underLOA: false,
    },
    {
      utility: 'CenterPoint',
      underLOA: false,
    },
    {
      utility: 'Sharyland',
      underLOA: false,
    },
    {
      utility: 'AEP',
      underLOA: false,
    },
    {
      utility: 'TNMP',
      underLOA: false,
    },
  ];

  constructor(
    private commercialService: CommercialService,
    private router: Router,
    private http: HttpClient
  ) {}

  pad(number) {
    return (number < 10 ? '0' : '') + number;
  }

  ngOnInit() {
    this.uploader.onAfterAddingFile = (file) => {
      this.invalidFileMsg = false;
      this.invalidFileSizeMsg = false;
      file.withCredentials = false;
      for (let i = 0; i < this.uploader.queue.length; i++) {
        if (
          this.uploader.queue[i].file.type === 'image/png' ||
          this.uploader.queue[i].file.type === 'image/bmp' ||
          this.uploader.queue[i].file.type === 'image/svg+xml' ||
          this.uploader.queue[i].file.type === 'image/jpeg' ||
          this.uploader.queue[i].file.type === 'application/pdf'
        ) {
          if (this.uploader.queue[i].file.size < 10000000) {
            const actualFileSize = filesize(this.uploader.queue[i].file.size);
            this.uploader.queue[i].file['unitSize'] = actualFileSize;
          } else {
            this.invalidFileSizeMsg = true;
            this.uploader.queue.pop();
          }
        } else {
          this.invalidFileMsg = true;
          this.uploader.queue.pop();
        }
      }
    };
    // console.log.log(this.uploader.queue.length);
    this.uploader.onCompleteItem = (
      item: any,
      response: any,
      status: any,
      headers: any
    ) => {
      this.uploadedFilename.push(response);
      this.commercialService.attachments.push(response);
    };
    // PDF: To get the values from localstorage
    let userResponse = sessionStorage.getItem('commercialResponses');
    if (!_.isEmpty(userResponse)) {
      userResponse = JSON.parse(userResponse);
      // To get the contact info
      const obj = _.findWhere(userResponse['userResponses'], {
        com_question_id: '0022',
      });
      if (!_.isEmpty(obj)) {
        this.contactInfo = obj.fieldValue;
      }

      // To get the address
      const addressObj = _.findWhere(userResponse['userResponses'], {
        com_question_id: '004',
      });
      if (!_.isEmpty(addressObj)) {
        this.address = addressObj.fieldValue;
        for (let i = 0; i < this.address.length; i++) {
          for (let j = 0; j < this.utilities.length; j++) {
            const uti = '\\b' + this.utilities[j].utility + '\\b';
            if (this.address[i].utility.match(new RegExp(uti, 'g'))) {
              this.utilities[j].underLOA = true;
            }
          }
        }
        // To get the state and city
        // start loop to get state from zip
        for (
          let i = 0;
          i < this.address[0].geoMapAddress['address_components'].length;
          i++
        ) {
          for (
            let j = 0;
            j <
            this.address[0].geoMapAddress['address_components'][i].types.length;
            j++
          ) {
            // To get the state
            if (
              this.address[0].geoMapAddress['address_components'][i].types[
                j
              ] === 'administrative_area_level_1'
            ) {
              if (
                !_.isEmpty(
                  this.address[0].geoMapAddress['address_components'][i]
                    .long_name
                )
              ) {
                this.state =
                  this.address[0].geoMapAddress['address_components'][
                    i
                  ].long_name;
              }
            }

            // street number
            if (
              this.address[0].geoMapAddress['address_components'][i].types[
                j
              ] === 'street_number'
            ) {
              if (
                !_.isEmpty(
                  this.address[0].geoMapAddress['address_components'][i]
                    .long_name
                )
              ) {
                this.streetNo =
                  this.address[0].geoMapAddress['address_components'][
                    i
                  ].long_name;
              }
            }
            // streer address 1
            if (
              this.address[0].geoMapAddress['address_components'][i].types[
                j
              ] === 'locality'
            ) {
              if (
                !_.isEmpty(
                  this.address[0].geoMapAddress['address_components'][i]
                    .long_name
                )
              ) {
                this.streetAdd1 =
                  this.address[0].geoMapAddress['address_components'][
                    i
                  ].long_name;
              }
            }
            // streer address 2
            if (
              this.address[0].geoMapAddress['address_components'][i].types[
                j
              ] === 'route'
            ) {
              if (
                !_.isEmpty(
                  this.address[0].geoMapAddress['address_components'][i]
                    .long_name
                )
              ) {
                this.streetAdd2 =
                  this.address[0].geoMapAddress['address_components'][
                    i
                  ].long_name;
              }
            }
            // city
            if (
              this.address[0].geoMapAddress['address_components'][i].types[
                j
              ] === 'administrative_area_level_2'
            ) {
              if (
                !_.isEmpty(
                  this.address[0].geoMapAddress['address_components'][i]
                    .long_name
                )
              ) {
                this.city =
                  this.address[0].geoMapAddress['address_components'][
                    i
                  ].long_name;
              }
            }

            // country
            if (
              this.address[0].geoMapAddress['address_components'][i].types[
                j
              ] === 'country'
            ) {
              if (
                !_.isEmpty(
                  this.address[0].geoMapAddress['address_components'][i]
                    .long_name
                )
              ) {
                this.country =
                  this.address[0].geoMapAddress['address_components'][
                    i
                  ].long_name;
              }
            }
            // To get the zip code
            if (
              this.address[0].geoMapAddress['address_components'][i].types[
                j
              ] === 'postal_code'
            ) {
              if (
                !_.isEmpty(
                  this.address[0].geoMapAddress['address_components'][i]
                    .long_name
                )
              ) {
                this.zipCode =
                  this.address[0].geoMapAddress['address_components'][
                    i
                  ].long_name;
              }
            }
          }
        }
      }

      // To get the business name
      const businessObj = _.findWhere(userResponse['userResponses'], {
        com_question_id: '0019',
      });
      if (!_.isEmpty(businessObj)) {
        this.buisnessName = businessObj.fieldValue;
      }
    }

    // For PDF date
    const time = new Date().getTime();
    // To get the date format
    const today = new Date();
    const dd = String(today.getDate()).padStart(2, '0');
    const mm = String(today.getMonth() + 1).padStart(2, '0'); // January is 0!
    const yyyy = today.getFullYear();

    // today = mm + '/' + dd + '/' + yyyy;
    this.footerDate = mm + dd + yyyy;
    this.fileName = mm + dd + yyyy;
    // To set the header Date
    const monthNames = [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
    ];
    this.headerDate =
      this.pad(new Date().getDate()) +
      ' ' +
      monthNames[today.getMonth()] +
      ' ' +
      today.getFullYear();
    this.typingTimer = setTimeout(() => {
      this.showTyping = true;
    }, 250);
    this.timer = setTimeout(() => {
      this.showTyping = false;
      this.showArrowbox2 = true;
    }, this.time);
  }
  removeFile(removedfile) {
    removedfile.remove();
    if (this.uploader.queue.length < 5) {
      this.errorMsg = false;
    }
  }
  public fileOverAnother(e: any): void {
    this.hasAnotherDropZoneOver = e;
  }

  submitFiles() {
    if (this.uploader.queue.length > 0) {
      this.uploader.uploadAll();
      // AS file upload may take time setting the time out to send congrats email
      setTimeout(() => {
        this.setUserResponses();
      }, 4000);
      this.router.navigateByUrl('/commercial/congrats');
    } else {
      this.sendEmailWithoutAttachments();
      this.router.navigateByUrl('/commercial/congrats');
    }
  }

  sendEmailWithoutAttachments() {
    if (this.uploader.queue.length === 0) {
      this.setUserResponses();
    }
  }

  setUserResponses() {
    const userResponses = {
      com_user_responce: this.commercialService.userResponse.userResponses,
      attachments: this.commercialService.attachments,
      addAddress: this.commercialService.addAddress,
    };
    const enrollbody = new HttpParams()
      .append('userResponses', JSON.stringify(userResponses))
      .append('enrollContactObj', localStorage.getItem('enrollContactObj'));
    this.http
      .post(this.url + '/commercial/congrats', enrollbody)
      .subscribe((notifyres: any) => {
        const result = notifyres;
      });
  }

  contactBack() {
    this.router.navigateByUrl('/commercial/enrollment');
    this.commercialService.messageService({ backFrom: 'preCongrats' });
  }
  // downloadPdf() {

  // }
  public downloadPdf() {
    // opem loader modal
    this.openModal();

    const data = document.getElementById('contentToConvert1');
    const w = document.getElementById('contentToConvert1').offsetWidth;
    const h = document.getElementById('contentToConvert1').offsetHeight;
    // Will download the pdf in single page
    const filename =
      'Honest Gorilla_LOA_Please Sign and Return_' + this.fileName + '.pdf';

    (html2canvas as any)(document.querySelector('#contentToConvert1'), {
      scale: 4,
    }).then((canvas) => {
      // add the margin
      document.querySelector('#contentToConvert1')['style'].marginTop = '20px';
      const pdf = new jspdf('p', 'mm', 'a4');
      pdf.addImage(
        canvas.toDataURL('image/png'),
        'PNG',
        0,
        0,
        210,
        298,
        'someAlias',
        'MEDIUM'
      );

      pdf.save(filename);
      // cloase modal
      this.onCloseHandled();
    });
  }
  // to open the modal
  openModal() {
    this.display = 'block';
  }
  // to close the modal
  onCloseHandled() {
    this.display = 'none';
  }
}
